import { Component,OnInit } from '@angular/core';
import { DTOInformacaoUsuario } from '../../dto/dtoInfomacaoUsuario';
import { NavParams,NavController,LoadingController,Refresher,ToastController,AlertController } from 'ionic-angular';
import { ListaBrindePage } from '../../pages/lista-brinde/lista-brinde';
import { SolicitarPixPage } from '../solicitar-pix/solicitar-pix';
import { DTOAcompanharPedido } from '../../dto/dtoAcompanharPedido';
import { DTOEntregaPedido } from '../../dto/dtoEntregaPedido';
import { PedidoDAO } from '../../daos/pedido-dao';
import moment from 'moment';
moment.locale('pt-BR');

@Component({
    selector: 'home-page',
    templateUrl: './home.html'
})
export class HomePage implements OnInit  {
    public pedidoFaturadoSemDataEntrega: DTOAcompanharPedido[] = [];
    public usuario: DTOInformacaoUsuario;
    vNomeUsuario: string;
    vChecarGrpClientePix: boolean= false;

    constructor(private _navCtrl: NavController,private _loadingCtrl: LoadingController,
        private _toastCtrl: ToastController,private _alertCtrl: AlertController,private _pedidoDao: PedidoDAO,_navParams: NavParams) {
        
        this.usuario = _navParams.get('usuario');
        this.vNomeUsuario = this.usuario.NomeUsuario.substring(0, this.usuario.NomeUsuario.indexOf(" "));
        if (this.vNomeUsuario.length == 0){
            this.vNomeUsuario = this.usuario.NomeUsuario;   
        }
    }

    ngOnInit(): void {
        if (this.usuario.Perfil == 'VENDEDOR'){
            this.obterPedidoFaturadoSemDtEntrega();
        }
        
        if (this.usuario.Empresa.Id == 2){
            this.checarGrupoClientePix(this.usuario.CnpjEmpresaUsuario);
        } 
    }

    checarGrupoClientePix(pCNPJ: string):void{
        this._pedidoDao.VerificarGrupoClientePix(pCNPJ)
            .then(retorno => {
                if (retorno=='ok'){
                    this.vChecarGrpClientePix = true;
                }   
            
            
            }
        );    
       
          
    }

    public obterPedidoFaturadoSemDtEntrega(refresher?: Refresher): void {
        let load = this._loadingCtrl.create({ content: 'Obtendo Pedido Faturado Sem Data de Entrega...' });
        if (!refresher)
            load.present();
            this._pedidoDao.listaPedidoSemEntrega(this.usuario.Empresa.Id, this.usuario.IdUsuario ).then(lstPedido => {                    
            this.pedidoFaturadoSemDataEntrega = lstPedido;

            if (!refresher) load.dismiss(); else refresher.complete();
        }).catch(error => {            
            if (!refresher) load.dismiss(); else refresher.complete();
            this._toastCtrl.create({
                message: 'Ocorreu um erro ao tentar obter os pedidos faturados sem data de entrega. Tente novamente!',
                duration: 3000
            }).present();        
        });    
    }

    public confirmarRecebimento(item): void { 
        
        this._alertCtrl.create({
            title: 'Informe a data de recebimento',
            subTitle: `Pedido número ${item.NumPedido}.`,
            inputs: [
                {
                    name: 'Data',
                    type:"date"    
                },
            ],
            buttons: [
                {
                    text: 'Não',
                    role: 'destructive'
                },
                {
                    text: 'Sim',
                    handler: (data) => {
                        if (data.Data.length == 0) {
                            this.alertaDeAviso('Data de Entrega é obrigatório!');
                            return;
                        }            
                        //console.log(data.Data);
                        var dto = new DTOEntregaPedido();
                        dto.DtEntrega = data.Data;
                        dto.Empresa = this.usuario.Empresa;
                        dto.IdUsuario = this.usuario.IdUsuario;
                        dto.PrimeiraCartela = item.PrimeiraCartela;
                        this._pedidoDao.gravarEntregaPedido(dto)
                        .then(r => {
                            const index = this.pedidoFaturadoSemDataEntrega.indexOf(item);
                            this.pedidoFaturadoSemDataEntrega.splice(index, 1);  
                            this.alertaDeSucesso('Gravado com sucesso!');
                        }, err => {
                            this.alertaErro(`Houve um erro inesperado. ${err.mensagem}`);
                        }); 
                      
                             
                                             
                        
                        
                    }
                }
            ]
        }).present();
    
    }

    alertaDeSucesso(msg: string) {
        this._alertCtrl.create({
            message: msg,
            title: 'Sucesso 😀 ️',
            buttons: [{
                text: 'Ok'
            }]
        }).present();
    }

    alertaErro(msg: string) {
        this._alertCtrl.create({
            message: msg,
            title: 'Ops... 😔',
            buttons: [{
                text: 'Ok, estou ciente'
            }]
        }).present();
      }

    alertaDeAviso(msg: string) {
        this._alertCtrl.create({
            message: msg,
            title: 'Atenção ⚠️',
            buttons: [{
                text: 'Ok'
            }]
        }).present();
    }

    pushPageBride(picote: number) {   
        this._navCtrl.push(ListaBrindePage,{qtdePicote:picote, usu: this.usuario });
    }

    pushPagePix(picote: number) {   
        this._navCtrl.push(SolicitarPixPage,{qtdePicote:picote, usu: this.usuario });
    }


}


// WEBPACK FOOTER //
// ./src/pages/home/home.ts